import React from 'react';

export const TCSLogo = ({ size = 'md', className = '', showTagline = true }) => {
  const sizes = {
    sm: { img: 'h-10', container: 'gap-2', tagline: 'text-[10px]' },
    md: { img: 'h-14', container: 'gap-3', tagline: 'text-xs' },
    lg: { img: 'h-20', container: 'gap-4', tagline: 'text-sm' },
    xl: { img: 'h-28', container: 'gap-5', tagline: 'text-base' }
  };
  
  const s = sizes[size] || sizes.md;
  
  return (
    <div className={`flex flex-col items-center ${className}`}>
      <img 
        src="/images/tcs-logo.png" 
        alt="TCS Assessoria Esportiva" 
        className={`${s.img} w-auto object-contain`}
      />
      {showTagline && (
        <p className={`${s.tagline} tracking-[0.3em] uppercase font-bold text-[#00F0FF] mt-3`} style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          TCS ASSESSORIA ESPORTIVA
        </p>
      )}
    </div>
  );
};

export default TCSLogo;
